export default "__VITE_ASSET__R2JK1M05__"